import { Ng2FileInputModule } from 'ng2-file-input';
// @Angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

// Third party
import { TranslateModule } from '@ngx-translate/core';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { Ng2Webstorage } from 'ngx-webstorage';
import { ToastrModule } from 'ngx-toastr';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PaginationModule } from 'ngx-bootstrap/pagination';

// Local modules
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { HomeModule } from './home/home.module';
import { LoginModule } from './login/login.module';
import { ExamplesModule } from './examples/examples.module';
import { IwFormsModule } from './forms/iw-forms.module';
import { FlowModule } from './flow/flow.module';
import { AdministrationModule } from './administration/administration.module';
import { CalendarModule } from './calendar/calendar.module';
import { AppRoutingModule } from './app-routing.module';

// Local components
import { AppComponent } from './app.component';

import { environment as env } from '@env/environment';

// Config JwtModule
export function jwtOptionsFactory() {
  return {
    whitelistedDomains: env.whitelistedDomains,
    skipWhenExpired: true,
    tokenGetter: () => {
      const credentialKey = `${env.storage.prefix}${env.storage.separator}${env.credentialsKey}`;
      const ss = JSON.parse(sessionStorage.getItem(credentialKey)) || {};
      const ls = JSON.parse(localStorage.getItem(credentialKey)) || {};
      if ((ss || ls) && (ss.hasOwnProperty('token') || ls.hasOwnProperty('token'))) {
        return ss.token || ls.token;
      }
      return null;
    }
  };
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    Ng2Webstorage.forRoot(env.storage),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory
      }
    }),
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    TranslateModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    ScrollToModule.forRoot(),
    Ng2FileInputModule.forRoot(),
    CoreModule,
    SharedModule,
    IwFormsModule,
    FlowModule,
    HomeModule,
    LoginModule,
    ExamplesModule,
    AdministrationModule,
    CalendarModule,
    AppRoutingModule
  ],
  declarations: [AppComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts